// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"r6PMO","loader":"_3Rev5","load6":"ChqBc","medium":"hGKD3","mini":"hDUZ6"};